import React, { useState } from 'react';
import { Modal, Input, Collapse, Button, Tooltip } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';

const { Panel } = Collapse;

const searchItems = (items, searchTerm) => {
  return items
    .map(item => {
      if (item.label.toLowerCase().includes(searchTerm.toLowerCase())) {
        return item;
      }

      if (item.children) {
        const filteredChildren = searchItems(item.children, searchTerm);
        if (filteredChildren.length > 0) {
          return { ...item, children: filteredChildren };
        }
      }

      return null;
    })
    .filter(item => item !== null);
};

const renderPanels = (items) => {
  const dateStyle = {
    float: 'right',
    clear: 'both'
  };
  const panels = items.map(item => {
    if (item?.date) {
      return (
        <Panel header={<span>{item.label} <span style={dateStyle}>{item.date}</span></span>} key={item.name}>
          {item.tooltip}
          {item.children && <Collapse>{renderPanels(item.children)}</Collapse>}
        </Panel>
      );
    } else {
      return (
        <Panel header={item.label} key={item.name}>
          {item.tooltip}
          {item.children && <Collapse>{renderPanels(item.children)}</Collapse>}
        </Panel>
      );
    }
  });
  return panels;
};



const FieldInfoModal = ({ visible, onClose, fieldInfo, releaseNote=false }) => {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredFieldInfo = searchItems(fieldInfo, searchTerm);

  const generateExcel = (versionReleaseNote) => {
    console.log('called the file on click only')
     const workbook = XLSX.utils.book_new();
   
     versionReleaseNote.forEach(version => {
       const sheetData = [];
       const addChildrenToSheet = (children, depth = 0) => {
         children.forEach(child => {
           sheetData.push({
             Name: child.name,
             Label: child.label,
             Tooltip: child.tooltip,
             Depth: depth,
           });
           if (child.children) {
             addChildrenToSheet(child.children, depth + 1);
           }
         });
       };
   
       sheetData.push({
         Name: version.name,
         Label: version.label,
         Tooltip: version.tooltip,
         Date: version.date,
         Depth: 0,
       });
   
       if (version.children) {
         addChildrenToSheet(version.children, 1);
       }
   
       const worksheet = XLSX.utils.json_to_sheet(sheetData);
       XLSX.utils.book_append_sheet(workbook, worksheet, version.name);
     });
   
     const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
     const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
     saveAs(blob, 'ECoTripVersionReleaseNotes.xlsx');
   };

  return (
    <Modal
      title="Release Version Note"
      visible={visible}
      onCancel={onClose}
      footer={null}
      style={{overflowY:'auto', maxHeight:'600px'}}
    >
    <div style={{display:'flex', gap:'0.5rem', marginBottom:'2px'}}>
    <>
      <Input
        placeholder="Search field"
        value={searchTerm}
        onChange={e => setSearchTerm(e.target.value)}
      />
     {releaseNote ? ( 
     <Tooltip title="Download Release note">

     <Button  onClick={() => {generateExcel(fieldInfo)}}><DownloadOutlined /></Button>
     </Tooltip>):<></>
     }
      </>
    </div>
      <Collapse>
        {renderPanels(filteredFieldInfo)}
      </Collapse>
    </Modal>
  );
};

export default FieldInfoModal;
